import { gql } from 'apollo-angular';
import fragments from '../../graphql/user';

export const currentUser = gql`
  ${fragments.baseUserInfoFragment}
  query currentUser {
    me {
      ...UserInfoFragment
    }
  }
`;
export const currentUserWithProfile = gql`
  ${fragments.baseUserInfoFragment}
  ${fragments.userProfileFragment}
  ${fragments.userPersonFragment}
  query currentUserWithProfile {
    me {
      ...UserInfoFragment
      ...UserProfileFragment
      ...UserPersonFragment
    }
  }
`;
export default {
  currentUser,
  currentUserWithProfile,
};
